<template>
  <b-select
    v-model="form.docTypeClassId"
    :error-messages="getErrorMessages(v$.docTypeClassId)"
    :items="$directory.get('docTypeClasses')"
    :loading="$loading.isLoading('docTypeClasses')"
    item-title="name"
    item-value="id"
    label="Клас документа"
    @blur="v$.docTypeClassId.$touch()"
    @focus="$directory.fill('docTypeClasses')" />
  <b-input
    v-model="form.code"
    :error-messages="getErrorMessages(v$.code)"
    label="Код"
    placeholder="Введіть код"
    @blur="v$.code.$touch()" />
  <b-input
    v-model="form.name"
    :error-messages="getErrorMessages(v$.name)"
    label="Назва"
    placeholder="Введіть назву"
    @blur="v$.name.$touch()" />
  <b-select
    v-model="form.registrationMarkType"
    :items="registrationMarkTypes"
    clearable
    label="Тип реєстраційної відмітки" />
  <b-textarea
    v-model="form.description"
    label="Опис"
    placeholder="Введіть опис"
    rows="3" />
</template>
<script>
import { onMounted, reactive } from 'vue'
import { required, useVuelidate } from '@/plugins'
import { getErrorMessages } from '@/utils/helpers'
import { docTypeDefinitionCreate } from '@/requests/documentType'
import { fillDirectory, pushDirectoryItem } from '@/directory'
import { BTextarea } from 'best-modules/components/index'
import { pick } from 'lodash'

export default {
  name: 'DocTypeDefinition',
  components: {
    BTextarea,
  },
  props: {
    dialog: { type: Object, required: true },
  },
  methods: { getErrorMessages },
  setup() {
    const registrationMarkTypes = [
      { name: 'Штрих-код', id: 'barcode' },
      { name: 'QR-код', id: 'qrcode' },
    ]

    const form = reactive({
      docTypeClassId: null,
      code: null,
      name: null,
      registrationMarkType: null,
      description: null,
    })

    const rules = {
      docTypeClassId: { required },
      code: { required },
      name: { required },
    }

    const v$ = useVuelidate(rules, form)

    const submit = () => {
      return docTypeDefinitionCreate(form).then(res => {
        pushDirectoryItem(
          'docTypeDefinitions',
          pick(res, ['code', 'docTypeClassId', 'id', 'name'])
        )
        return res
      })
    }

    onMounted(() => {
      fillDirectory('docTypeClasses')
    })

    return { form, v$, submit, registrationMarkTypes }
  },
}
</script>
